import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';

class Bucket extends Component {

  constructor(props) {
    super(props);

    this.toggleFacet = this.toggleFacet.bind(this);

    this.state = {
      checked: false
    };
  }

  componentWillMount() {
    const { facet, facetValue, selectedFacetValues } = this.props;
    if (selectedFacetValues[facet.key]) {
      if (_.indexOf(selectedFacetValues[facet.key], facetValue.key) > -1) {
        this.setState({
          checked: true
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.selectedFacetValues).length === 0) this.setState({ checked: false });
  }

  toggleFacet() {
    const { facet, facetValue, onToggleFacet } = this.props;

    this.setState({
      checked: !this.state.checked
    });

    onToggleFacet(facet.key, facetValue.key);
  }

  formatFacetValueLabel(facet, facetValue) {
    if (facet.key === 'RELATIONSHIP') {
      const { wedding } = this.props;

      switch (facetValue.key) {
        case 'PRIMARY_FAMILY':
        case 'PRIMARY_WEDDING_PARTY':
        case 'PRIMARY_FRIEND':
        case 'PRIMARY_FAMILY_FRIEND':
          return `${wedding.owner_first_name}'s ${facetValue.label}`;
        case 'PARTNER_FAMILY':
        case 'PARTNER_WEDDING_PARTY':
        case 'PARTNER_FRIEND':
        case 'PARTNER_FAMILY_FRIEND':
          return `${wedding.partner_first_name}'s ${facetValue.label}`;
        case 'BOTH':
          return `${wedding.owner_first_name} and ${wedding.partner_first_name}'s Friends`;
        default:
          return facetValue.label;
      }
    }
    return facetValue.label;
  }

  fixMe() {
    const { selectedFacetValues } = this.props;
    return selectedFacetValues && true;
  }

  render() {
    const { facet, facetValue } = this.props;

    return (
      <li key={facetValue.key}>
        <div className="checkbox">
          <label htmlFor={`${facet.key}-${facetValue.key}`}>
            <input id={`${facet.key}-${facetValue.key}`} type="checkbox" value={facetValue.key} onChange={this.toggleFacet} checked={this.state.checked} />
            <span className="input-override"><i className="zolaicon zolaicon-checkmark" /></span>
            {this.formatFacetValueLabel(facet, facetValue)} ({facetValue.count})
          </label>
        </div>
      </li>
    );
  }
}

Bucket.propTypes = {
  facet: PropTypes.shape({}),
  facetValue: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  wedding: PropTypes.shape({})
};

const Facet = ({ facet, selectedFacetValues, onToggleFacet, wedding }) => {
  if (!facet.buckets || facet.buckets.length === 0) return null;

  return (
    <div key={facet.key} className="facet">
      <div className="form-label">{facet.label}</div>
      <ul className="list-unstyled">
        {facet.buckets && facet.buckets.map(facetValue => (
          <Bucket key={facetValue.key} facet={facet} facetValue={facetValue} selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} wedding={wedding} />
        ))}
      </ul>
    </div>
  );
};


Facet.propTypes = {
  facet: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  selectedFacetValues: PropTypes.shape({}),
  wedding: PropTypes.shape({})
};

const FacetList = ({ facets, selectedFacetValues, onToggleFacet, onResetFacets, wedding }) => {
  const hasFacetsSelected = !!_.size(selectedFacetValues);

  return (
    <div className="facets">
      {hasFacetsSelected && (
        <a role="button" className="pull-right" onClick={onResetFacets}>Clear</a>
      )}
      {facets.map(facet => (
        <Facet key={facet.key} facet={facet} selectedFacetValues={selectedFacetValues} onToggleFacet={onToggleFacet} wedding={wedding} />
      ))}
    </div>
  );
};

FacetList.propTypes = {
  facets: PropTypes.arrayOf(PropTypes.shape({})),
  selectedFacetValues: PropTypes.shape({}),
  onToggleFacet: PropTypes.func.isRequired,
  onResetFacets: PropTypes.func.isRequired,
  wedding: PropTypes.shape({})
};

const mapStateToProps = state => ({
  facets: state.guestList.guests.facets,
  selectedFacetValues: state.guestList.guests.selectedFacetValues,
  wedding: state.wedding.wedding
});

export default connect(
  mapStateToProps
)(FacetList);



/** WEBPACK FOOTER **
 ** ./src/components/manage/guestlist/Facets.jsx
 **/